var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "checked-icon"
  }, [_c('svg', {
    attrs: {
      "width": "13",
      "height": "11",
      "viewBox": "0 0 13 11",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M1 6L5 9L12 1",
      "stroke": "#149FED",
      "stroke-width": "2"
    }
  })])]);
}
var staticRenderFns = []

export { render, staticRenderFns }